import React from "react";
import ToggleSwitch from "./Buttons/Togglebtn";

const Card = ({
  maintitle = "No title",
  cardWidth = "",
  cardColor = "#FFFFFF",
  cardTitle = "",
  cardContent = "",
  cardIconOne,
  cardIconTwo,
  onclickOne,
  onClickTwo,
  classes = "",
  status = "no status",

  // Toggle props
  checked = false,
  onToggle = () => {},
}) => {
  return (
    <>
      <div
        className={`bg-${cardColor} max-w-md w-${cardWidth} border border-gray-200 rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-300 flex flex-col justify-between ${classes}`}
        style={{ minHeight: "230px" }} // ensures footer stays at bottom
      >
        <div className="flex flex-col gap-4 flex-grow">
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 sm:gap-0 border-b border-gray-200 pb-2">
            <h1 className="text-gray-900 font-bold text-lg">{cardTitle}</h1>

            <div className="flex gap-2">
              <button
                className="bg-[#fff0ec] text-[#ff7448] font-bold text-sm px-2 py-2 rounded-md cursor-pointer"
                onClick={onclickOne}
              >
                {cardIconOne}
              </button>

              <button
                className="bg-[#fff0ec] text-[#ff7448] font-bold text-sm px-2 py-2 rounded-md cursor-pointer"
                onClick={onClickTwo}
              >
                {cardIconTwo}
              </button>
            </div>
          </div>

          {/* Content */}
          <p className="text-gray-600 text-sm leading-relaxed flex-grow">
            {cardContent}
          </p>
        </div>

        {/* Footer ALWAYS at bottom */}
        <div className="pt-3 border-t border-gray-200 flex justify-between items-center mt-auto">
          <span
            className={`text-sm font-medium ${
              status === "Active" ? "text-green-600" : "text-red-600"
            }`}
          >
            {status}
          </span>

          <ToggleSwitch
            checked={checked}
            onChange={onToggle}
            width={38} // small toggle
            height={18}
            swal={false}
            handleDiameter={18}
            onColor="#b4f6c4" // light green
            offColor="#ffb3b3" // light red
            handleColor="#ffffff"
            checkedIcon={false}
            uncheckedIcon={false}
            showStatus={false}
          />
        </div>
      </div>
    </>
  );
};

export default Card;
